module.exports = __webpack_public_path__ + "img/414.6a05486f.jpg";